// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--bfoBV";
export var LogoLayout = "Footer-module--LogoLayout--+B4Mm";
export var Top = "Footer-module--Top--vNepd";
export var LogoWrap = "Footer-module--LogoWrap--L-bjg";
export var Logo = "Footer-module--Logo--kKRNo";
export var FooterLegal = "Footer-module--FooterLegal--s0rC6";
export var Copyright = "Footer-module--Copyright--zdkch";
export var Policy = "Footer-module--Policy--QpvPm";
export var Author = "Footer-module--Author--R6BTW";
export var LangHY = "Footer-module--LangHY--WZ3yL";
export var Col = "Footer-module--Col--5VM5+";
export var ColContacts = "Footer-module--ColContacts--350ps";
export var ColTitle = "Footer-module--ColTitle---PCk6";
export var ColItem = "Footer-module--ColItem--kJ7d3";
export var ColItems = "Footer-module--ColItems--ulDPC";
export var Lang = "Footer-module--Lang--yKmBQ";
export var Bottom = "Footer-module--Bottom--U4cDA";
export var Inner = "Footer-module--Inner--Q6cgo";
export var First = "Footer-module--First--xbx-o";
export var ColInner = "Footer-module--ColInner--obFFl";
export var Right = "Footer-module--Right--IpLtZ";
export var ColCompany = "Footer-module--ColCompany--S6AnV";
export var ColProjects = "Footer-module--ColProjects--Q32At";
export var arrowLeft = "Footer-module--arrowLeft--HUtYd";
export var arrowRight = "Footer-module--arrowRight--iEdPD";